export class NodesUpdateResponse {
  constructor(warehouse, paramName, paramValue) {
    this.warehouse = warehouse;
    this.paramName = paramName;
    this.paramValue = paramValue;
  }
}
